module.exports = __webpack_public_path__ + "static/media/anchor.1f336691.webp";